export default {
  SET_PLACE_OF_WORK(state, data) {
    state.placeOfWork = data
  },
}
